import { TableRow, TableCell } from '@material-ui/core'
import styled from 'styled-components'

export const StyledTableRow = styled(TableRow)`
  cursor: pointer;

  &.zebra {
    background-color: #f8f8f8;
  }
`
export const StyledCollapsibleRow = styled(TableRow)`
  && {
    background-color: #ebebeb;
    border-collapse: collapse;
    box-shadow: inset 0px -2px 4px rgba(0, 0, 0, 0.1);

    ${props => (props.visible ? 'display: table-row' : 'display: none')};

    &.zebra {
      background: #c8c8c8;
      box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.15);
    }

    td,
    a {
      border: 0;
      color: ${props => props.theme.colors.secondary};
      font-family: ${props => props.theme.fonts.robotoRegular};
      font-size: 14px;
      text-decoration: none;
    }
  }
`

export const StyledTableCell = styled(TableCell)`
  && {
    border: 0;
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    font-size: 14px;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`

export const StyledFlyerPacksCell = styled(StyledTableCell)`
  &&.MuiTableCell-root {
    ${props => (props.highlight ? 'color: #FF1313; font-weight: 600;' : '')};
  }
`
export const StyledHeadRow = styled(TableRow)`
  height: 48px;
`

export const StyledTableHeadCell = styled(TableCell)`
  && {
    border: 0;
    color: #595959;
    font-family: ${props => props.theme.fonts.robotoRegular};
    font-size: 10.5px;
    letter-spacing: 1.5px;
    line-height: 12px;
    padding-bottom: 0;
    padding-top: 0;
    text-transform: uppercase;
  }
`

export const StyledRedirectButton = styled.button`
  background: inherit;
  border: none;
  padding: 0;
`
